import { useContext } from "react";

// context
import { StateContext } from "bodycodi/cmap/app/components/common/context";

// components
import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import SellerProfileForm from "./SellerProfileForm";

const SellerProfilePop = ({ seqPlusSeller, seqPartnerCoach, coachName }: any) => {
  const { state } = useContext(StateContext);

  return (
    <CustomDialog open={state.sellerProfilePop}>
      <SellerProfileForm
        seqPlusSeller={seqPlusSeller}
        seqPartnerCoach={seqPartnerCoach}
        coachName={coachName}
      />
    </CustomDialog>
  );
};

export default SellerProfilePop;
